import React from "react";
import i41 from "assets/images/i41.svg";
import styled from "react-emotion";

const Btn = styled("button")`
  background: transparent;
  transition: 100ms;
  :hover, :focus, :active {
    opacity: 0.7;
  }
`;

const CloseBtn = props => (
  <Btn {...props}>
    <img src={i41} alt="" />
  </Btn>
);

export default CloseBtn;


// WEBPACK FOOTER //
// ./src/components/ui/CloseBtn.jsx